
<template>
  <div class="carousel" :class="wrapperClasses">
    <slot></slot>
  </div>
</template>

<style src='flickity/dist/flickity.css'></style>

<script>
  export default {
    props: {
      wrapperClasses: {
        type: String,
        default: 'h-full',
      },
      options: {
        type: Object,
        default: () => {
          return {
            wrapAround: true,
            pageDots: true,
            setGallerySize: false,
            prevNextButtons: false,
          }
        },
      },
    },
    data() {
      return {
        carousel: null,
      };
    },
    mounted() {
      this.initiateCarousel();
    },

    methods: {
      initiateCarousel() {
        const Flickity = require('flickity');

        this.carousel = new Flickity(this.$el, this.options);

        window.addEventListener('load', () => {
          this.carousel.resize();
          window.setTimeout(() =>  this.carousel.resize(), 1000);
        });
      },
    },
  };
</script>
